export default __webpack_public_path__ + "static/media/gallery_08.6ad8379f.jpg";